import { FaultLogStatus } from "./Enums";

export class Pages {
  public static default = "/";
  public static dashboard = "Dashboard";
  public static dashboardPage = "DashboardPage";
  public static faultLogDetail = "FaultLogDetail";
  public static userManagement = "UserManagement";
  public static administration = "Administration";
  public static clientProfile = "ClientProfile";
}

export class Constants {
  public static Label_ID = "ID";
  public static Label_Status = "Status";
  public static Label_NumberOfDeliveries = "# of Deliveries in Last 30 Days";
  public static Label_AssetName = "Asset Name";
  public static Label_ClosedDate = "Closed Date (local time)";
  public static Label_CustomerFlag = "Customer Flag";
  public static Label_CustomerCity = "Customer City";
  public static Label_CustomerPostCode = "Customer Post Code";
  public static Label_ShipTo = "Customer Ship To";
  public static Label_DeviceID = "Device ID";
  public static Label_ImpactOnLogistics = "Impact On Logistics";
  public static Label_Country = "Country";
  public static Label_ReportedTime = "Reported Time (local time)";
  public static Label_ReportedBy = "Reported By";
  public static Label_RootCause = "Root Cause";
  public static Label_SapNotificationNumber = "SAP Notification Number";
  public static Label_SiteVisitDate = "Site Visit Date (local time)";
  public static Label_ToEngineeringDate = "To Engineering Date (local time)";

  public static Label_TelemetrySystem = "Telemetry System";
  public static Label_Priority = "Priority";
  public static Label_Product = "Product";
  public static Label_FaultCode = "Fault Code";
  public static Label_Region = "Region";
  public static Label_Owner = "Owner";
  public static Label_DeviceType = "Device Type";
  public static Label_Acknowledged = "Acknowledged";
  public static Label_AcknowledgedBy = "Acknowledged By";
  public static Label_VesselId = "Vessel ID";
  public static Label_WorkOrderUserStatus = "Work Order User Status";
  public static Label_CustomerName = "Customer Name";
  public static Label_CustomerShipTo = "Customer Ship To";
  public static Label_CustomerDemandType = "Customer Demand Type";
  public static Label_VesselID = "Vessel ID";
  public static Label_WorkOrderNumber = "Work Order Number";
  public static Label_LatestComments = "Latest Comments";
  public static Label_AcknowledgedTime = "Acknowledged Time (local time)";
  public static Label_NumOfDeliveriesInLast30Days = "# of Deliveries in Last 30 Days";
  public static Label_WorkOrderSystemStatus = "Work Order System Status";
  public static Label_WorkOrderUserStatusDesc = "Work Order User Status";
  public static Label_WorkOrderSystemStatusDesc = "Work Order System Status";
  public static Label_WorkOrderLongText = "Work Order Long Text";
  public static Label_SapNotifyResponseMessage = "SAP Notify Response Message";
  public static Label_NotificationStatus = " Notification Status";
  
  public static Field_ReportedTime = "ReportedTime";
  public static Field_ID = "Id";
  public static Field_Status = "status";
  public static Field_NumberOfDeliveries = "NumOfDeliveries";
  public static Field_AssetName = "AssetName";
  public static Field_ClosedDate = "ClosedDate";
  public static Field_CustomerFlag = "CustomerFlag";
  public static Field_CustomerDemandType = "CustomerDemandType";
  public static Field_CustomerCity = "CustomerCity";
  public static Field_CustomerPostCode = "CustomerPostCode";
  public static Field_ShipTo = "CustomerShipTo";
  public static Field_DeviceID = "DeviceID";
  public static Field_ImpactOnLogistics = "ImpactOnLogistics";
  public static Field_Country = "Country";
  public static Field_ReportedBy = "ReportedBy";
  public static Field_RootCause = "RootCause";
  public static Field_SapNotificationNumber = "SapNotificationNumber";
  public static Field_SiteVisitDate = "SiteVisitDate";
  public static Field_ToEngineeringDate = "ToEngineeringDate";

  public static Field_TelemetrySystem = "TelemetrySystem";
  public static Field_Priority = "Priority";
  public static Field_Product = "Product";
  public static Field_FaultCode = "FaultCode";
  public static Field_Region = "Region";
  public static Field_Owner = "Owner";
  public static Field_DeviceType = "DeviceType";
  public static Field_Acknowledged = "Acknowledged";
  public static Field_AcknowledgedBy = "AcknowledgedBy";
  public static Field_VesselId = "VesselId";
  public static Field_WorkOrderUserStatus = "WorkOrderUserStatus";
  public static Field_CustomerName = "CustomerName";

  public static FlashingColor_Red = "#ffcdd2";
  public static FlashingColor_Green = "#c8e6c9";

  public static WorkOrderUserStatus_Done = "DONE";
  public static WorkOrderUserStatus_FieldWorkIsDone = "Field Work Is Done";
  public static NA_REGION_PREFIX = "NA-";

  public static FAULT_CODE_BATTERY_MARK = "batt";

  public static NotificationStatus_NotificationCompleted = "Notification Completed";

  public static DEVICE_TYPE_PUBLISHED_DEVICE = "published_device";

  public static CREATE_BY_LEGACY = "legacy";
}

export class UserPermissionConstants {
  public static AddComment = "AddComment";
}

export class DomainConstants {
  public static NA = "North America";
  public static EU = "Europe";
}

// Centralized user role constants
export class UserRoleConstants {
  public static UserReaderRole = "FaultReader";
  public static UserAdminRole = "FaultAdmin";
  public static UserEditorRole = "FaultEditor";
  public static UserHandlerRole = "FaultHandler";
}

export class FaultCodeConstants {
  public static CommsLostSignalIssues = "Comms lost - signal issues";
  public static TotalizerReadingsDriftedApart = "Totalizer readings drifted apart";
  public static SolarBatteryPanelDisconnected = "Solar battery - panel disconnected";
  public static SolarBatteryEndOfLife = "Solar battery - end of life";
  public static MainsBatteryPowerDisconnected = "Mains battery - power disconnected";
  public static MainsBatteryEndOfLife = "Mains battery - end of life";
  public static PrimaryBatteryEndOfLife = "Primary battery - end of life";
  public static UncategorizedBatteryFault = "Uncategorized battery fault";
  public static ElectricalIssueCapacitor = "electrical issue - capacitor";
  public static ElectricalIssueShortCircuit = "electrical issue - short circuit";
  public static SensorDisconnected = "sensor disconnected";
  public static SensorWiredIncorrectly = "sensor wired incorrectly";
  public static SensorBlown = "sensor blown";
  public static ReadingsStuckAfterDelivery = "readings stuck after delivery";
  public static SensorReadingOscillations = "sensor - reading oscillations";
  public static SensorAnomalousReading = "sensor - anomalous reading";
  public static SensorReadingsStuckBetweenDeliveries = "sensor - readings stuck between deliveries";
  public static InactiveChannel = "inactive channel";
}

export const FaultCodeList = [
  FaultCodeConstants.CommsLostSignalIssues,
  FaultCodeConstants.ElectricalIssueCapacitor,
  FaultCodeConstants.ElectricalIssueShortCircuit,
  FaultCodeConstants.InactiveChannel,
  FaultCodeConstants.MainsBatteryEndOfLife,
  FaultCodeConstants.MainsBatteryPowerDisconnected,
  FaultCodeConstants.PrimaryBatteryEndOfLife,
  FaultCodeConstants.ReadingsStuckAfterDelivery,
  FaultCodeConstants.SensorAnomalousReading,
  FaultCodeConstants.SensorBlown,
  FaultCodeConstants.SensorDisconnected,
  FaultCodeConstants.SensorReadingOscillations,
  FaultCodeConstants.SensorReadingsStuckBetweenDeliveries,
  FaultCodeConstants.SensorWiredIncorrectly,
  FaultCodeConstants.SolarBatteryEndOfLife,
  FaultCodeConstants.SolarBatteryPanelDisconnected,
  FaultCodeConstants.TotalizerReadingsDriftedApart,
  FaultCodeConstants.UncategorizedBatteryFault,
];

export const BatteryFaultCodes = [
  FaultCodeConstants.MainsBatteryEndOfLife,
  FaultCodeConstants.MainsBatteryPowerDisconnected,
  FaultCodeConstants.PrimaryBatteryEndOfLife,
  FaultCodeConstants.SolarBatteryEndOfLife,
  FaultCodeConstants.SolarBatteryPanelDisconnected,
  FaultCodeConstants.UncategorizedBatteryFault
];

export const AlertAckConfigList = [
  // Comms lost - signal issues (same for EU and NA)
  {
    faultCode: FaultCodeConstants.CommsLostSignalIssues,
    domains: [DomainConstants.EU, DomainConstants.NA],
    userRoles: [UserRoleConstants.UserHandlerRole],
    status: FaultLogStatus.Open,
  },
  // Totalizer readings drifted apart
  {
    faultCode: FaultCodeConstants.TotalizerReadingsDriftedApart,
    domains: [DomainConstants.EU, DomainConstants.NA],
    userRoles: [UserRoleConstants.UserEditorRole],
    status: FaultLogStatus.Open,
  },
  // Solar battery - panel disconnected
  {
    faultCode: FaultCodeConstants.SolarBatteryPanelDisconnected,
    domains: [DomainConstants.EU],
    userRoles: [UserRoleConstants.UserHandlerRole],
    status: FaultLogStatus.Open,
  },
  {
    faultCode: FaultCodeConstants.SolarBatteryPanelDisconnected,
    domains: [DomainConstants.NA],
    userRoles: [UserRoleConstants.UserEditorRole],
    status: FaultLogStatus.Open,
  },
  // Mains battery - power disconnected
  {
    faultCode: FaultCodeConstants.MainsBatteryPowerDisconnected,
    domains: [DomainConstants.EU],
    userRoles: [UserRoleConstants.UserHandlerRole],
    status: FaultLogStatus.Open,
  },
  {
    faultCode: FaultCodeConstants.MainsBatteryPowerDisconnected,
    domains: [DomainConstants.NA],
    userRoles: [UserRoleConstants.UserEditorRole],
    status: FaultLogStatus.Open,
  },
  // Solar battery - end of life
  {
    faultCode: FaultCodeConstants.SolarBatteryEndOfLife,
    domains: [DomainConstants.NA],
    userRoles: [UserRoleConstants.UserEditorRole],
    status: FaultLogStatus.Draft,
  },
  // Mains battery - end of life
  {
    faultCode: FaultCodeConstants.MainsBatteryEndOfLife,
    domains: [DomainConstants.NA],
    userRoles: [UserRoleConstants.UserEditorRole],
    status: FaultLogStatus.Draft,
  },
  // electrical issue - capacitor (same for EU and NA)
  {
    faultCode: FaultCodeConstants.ElectricalIssueCapacitor,
    domains: [DomainConstants.EU, DomainConstants.NA],
    userRoles: [UserRoleConstants.UserHandlerRole],
    status: FaultLogStatus.Open,
  },
  // electrical issue - short circuit (same for EU and NA)
  {
    faultCode: FaultCodeConstants.ElectricalIssueShortCircuit,
    domains: [DomainConstants.EU, DomainConstants.NA],
    userRoles: [UserRoleConstants.UserHandlerRole],
    status: FaultLogStatus.Open,
  },
  // sensor disconnected
  {
    faultCode: FaultCodeConstants.SensorDisconnected,
    domains: [DomainConstants.EU, DomainConstants.NA],
    userRoles: [UserRoleConstants.UserEditorRole],
    status: FaultLogStatus.Open,
  },
  // sensor wired incorrectly
  {
    faultCode: FaultCodeConstants.SensorWiredIncorrectly,
    domains: [DomainConstants.EU, DomainConstants.NA],
    userRoles: [UserRoleConstants.UserEditorRole],
    status: FaultLogStatus.Open,
  },
  // sensor blown (EU only)
  {
    faultCode: FaultCodeConstants.SensorBlown,
    domains: [DomainConstants.EU],
    userRoles: [UserRoleConstants.UserEditorRole],
    status: FaultLogStatus.Open,
  },
  // Uncategorized battery fault
  {
    faultCode: FaultCodeConstants.UncategorizedBatteryFault,
    domains: [DomainConstants.EU, DomainConstants.NA],
    userRoles: [UserRoleConstants.UserEditorRole],
    status: FaultLogStatus.Draft,
  },
  // readings stuck after delivery
  {
    faultCode: FaultCodeConstants.ReadingsStuckAfterDelivery,
    domains: [DomainConstants.EU, DomainConstants.NA],
    userRoles: [UserRoleConstants.UserEditorRole],
    status: FaultLogStatus.Draft,
  },
  // sensor - reading oscillations
  {
    faultCode: FaultCodeConstants.SensorReadingOscillations,
    domains: [DomainConstants.EU, DomainConstants.NA],
    userRoles: [UserRoleConstants.UserEditorRole],
    status: FaultLogStatus.Draft,
  },
  // sensor - anomalous reading
  {
    faultCode: FaultCodeConstants.SensorAnomalousReading,
    domains: [DomainConstants.EU, DomainConstants.NA],
    userRoles: [UserRoleConstants.UserEditorRole],
    status: FaultLogStatus.Draft,
  },
  // sensor - readings stuck between deliveries
  {
    faultCode: FaultCodeConstants.SensorReadingsStuckBetweenDeliveries,
    domains: [DomainConstants.EU, DomainConstants.NA],
    userRoles: [UserRoleConstants.UserEditorRole],
    status: FaultLogStatus.Draft,
  },
];
